export const menuList = [{
    title: '注册信息',
    icon: 'icon-23',
    title_en: 'Register Info',
    list: [{
        text: '个人资料',
        url: '/user/userInfo',
        name: 'userInfo',
        text_en: 'UserInfo'
      },
      {
        text: '问卷调查',
        url: '/user/questionnaire',
        name: 'questionnaire',
        text_en: 'Questionnaire'
      }
    ]
  },
  {
    title: '个人中心',
    icon: 'icon-user',
    title_en: 'User Center',
    list: [{
        text: '我的确认函',
        url: '/user/confirmation',
        name: 'confirmation',
        text_en: 'Confirmation'
      },
      {
          text: 'VIP观众申请',
          url: '/user/vip',
          name: 'vip',
          text_en: 'VIP',
          languageID: 1
      }
    ]
  },
  {
    title: '展会服务',
    icon: 'icon-hezuowoshou',
    title_en: 'Visitor Service',
    list: [{
        text: '邀请好友',
        url: '/user/invitefriends',
        name: 'invitefriends',
        text_en: 'Invitefriends'
      },
      {
        text: '邀请结果',
        url: '/user/inviteresult',
        name: 'inviteresult',
        text_en: 'InviteResult'
      }
    ]
  }
]

// 下拉框数据
export const selectData = {
  salutation: [{
      TextCn: '先生',
      TextEn: 'Mr',
    },
    {
      TextCn: '女士',
      TextEn: 'Ms',
    }
  ],
  department: [{
      TextCn: '总部',
      TextEn: 'Headquarters',
    },
    {
      TextCn: '市场部',
      TextEn: 'Marketing Department',
    },
    {
      TextCn: '销售部',
      TextEn: 'Sales Department',
    },
    {
      TextCn: '采购部',
      TextEn: 'Purchase Department',
    },
    {
      TextCn: '研发/技术部',
      TextEn: 'R & D',
    },
    {
      TextCn: '其他',
      TextEn: 'Others',
    }
  ],
  position: [{
      TextCn: '企业法人',
      TextEn: 'Legal Representative',
      Code: 'COP01'
    }, {
      TextCn: '董事长',
      TextEn: 'Chairman',
      Code: 'COP02'
    }, {
      TextCn: '总经理',
      TextEn: 'General Manager',
      Code: 'COP03'
    },
    {
      TextCn: '店主',
      TextEn: 'Owner',
      Code: 'COP04'
    }, {
      TextCn: '个体老板',
      TextEn: 'Independent Business Owner',
      Code: 'COP05'
    }, {
      TextCn: '销售总监',
      TextEn: 'Sales Director',
      Code: 'SKG01'
    },
    {
      TextCn: '项目总监',
      TextEn: 'Project Director',
      Code: 'SKG02'
    },
    {
      TextCn: '市场总监',
      TextEn: 'Marketing Director',
      Code: 'SKG03'
    },
    {
      TextCn: '采购总监',
      TextEn: 'Purchasing Director',
      Code: 'SKG04'
    },
    {
      TextCn: '分支机构负责人',
      TextEn: 'Branch Manager',
      Code: 'MGR01'
    }, {
      TextCn: '零售店负责人',
      TextEn: 'Retail Store Manager',
      Code: 'MGR02'
    }, {
      TextCn: '店长',
      TextEn: 'Store Manager',
      Code: 'MGR03'
    },
    {
      TextCn: '负责人',
      TextEn: 'Manager',
      Code: 'MGR04'
    },
    {
      TextCn: '销售经理',
      TextEn: 'Sales Manager',
      Code: 'SPM01'
    },
    {
      TextCn: '项目经理',
      TextEn: 'Project Manager',
      Code: 'SPM02'
    }, {
      TextCn: '市场经理',
      TextEn: 'Marketing Manager',
      Code: 'SPM03'
    },
    {
      TextCn: '采购经理',
      TextEn: 'Purchasing Manager',
      Code: 'SPM04'
    },
    {
      TextCn: '雇员',
      TextEn: 'Employee',
      Code: 'EMP01'
    },
    {
      TextCn: '员工',
      TextEn: 'Staff',
      Code: 'EMP02'
    },
    {
      TextCn: '采购员',
      TextEn: 'Purchasing Staff',
      Code: 'EMP03'
    },
    {
      TextCn: '店员',
      TextEn: 'Store Staff',
      Code: 'EMP04'
    },
    {
      TextCn: '其他（请说明）',
      TextEn: 'Others（Please specific）',
      Code: 'OTH'
    }
  ]
}

export const selectTypes = {
  inputType: [
    "lastName",
    "mobile",
    "company",
    "emailAddress",
    "postCode",
    "address1",
    "firstName",
    "fax"
  ],
  selectType: [
    "salutation",
    "country",
    "state",
    "suburb",
    "department",
    "position",
  ]
}



// WEBPACK FOOTER //
// ./src/common/data.js